import { render } from "./ReportPage.vue?vue&type=template&id=5521b9da&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"

import "@/assets/css/reports.css?vue&type=style&index=0&lang=css&external"
import "./ReportPage.vue?vue&type=style&index=1&id=5521b9da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5521b9da"]])

export default __exports__